// =============================================
// COMPONENTE: DelayNode - Nó de Delay/Timer
// =============================================
// Arquivo: DelayNode.tsx
// Descrição: Nó para adicionar delays ou agendar execução
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Clock } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const DelayNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, delayType, duration, unit, description, actions } = data;

  const formatDelay = () => {
    if (delayType === 'fixed' && duration) {
      return `Aguardar ${duration} ${unit || 'segundos'}`;
    }
    if (delayType === 'until_response') {
      return 'Aguardar resposta do usuário';
    }
    if (delayType === 'schedule') {
      return 'Agendar para horário específico';
    }
    return 'Configurar delay';
  };

  return (
    <div className={`flow-node delay-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header delay-header">
        <Clock className="node-icon" size={18} />
        <span className="node-title">{label || 'Delay/Timer'}</span>
      </div>

      <div className="node-body">
        <div className="node-detail">
          <Clock size={14} />
          <span className="node-detail-text">{formatDelay()}</span>
        </div>
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="flow-handle"
      />
    </div>
  );
};

export default DelayNode;
